import axios from 'axios';
import beehiveApi from '../apis/whatsNew.api';
import auth from '../apis/auth.api';
export const retrieveWhatsNewItems = () => beehiveApi.get('/community/service/rest/cloudhelp/resource/cloudhelpchannel/search?', {
    params: {
        contextid: 'PRODUCT_WHATSNEW',
    },
});
export const updateLastSeenVersion = (params) => auth.patch('/lastWNVersionSeen', params);
export const fetchHTMLText = (url) => axios.get(url);
